import { render, staticRenderFns } from "./LocatieInformatieEdit.vue?vue&type=template&id=866e3d68&"
import script from "./LocatieInformatieEdit.vue?vue&type=script&lang=js&"
export * from "./LocatieInformatieEdit.vue?vue&type=script&lang=js&"
import style0 from "./LocatieInformatieEdit.vue?vue&type=style&index=0&id=866e3d68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports